import React, { useState, useRef, useEffect } from "react"
import { FakeScrollBox } from "../../OfferPage/FlatDescription/style"
import { useIntl, navigate } from "gatsby-plugin-react-intl"
import {
  MainForm,
  Wrapper,
  StyledInput,
  StyledTextArea,
  CheckBoxDiv,
  StyledGoldButton,
  MainHeader,
  FormMessage,
  CheckBoxText,
  Main,
  FormSubmit,
  FormMessageSpecial,
  CVBox,
  FileNameBox,
  RodoLink,
} from "./style"
import cvIcon from "../../../images/cv-icon.png"
import exitButton from "../../../images/exit-button2.png"

const FormComponent = ({
  message = "",
  enableAttachment = false,
  translations: {
    send,
    rodo,
    message: t_message,
    name,
    formSubtitle,
    mail,
    phone,
    contact_form,
    sendCv = "",
    validateName,
    validatePhone,
    validateEmail,
    validateMessage,
    validateCheckbox,
    validateCv,
    validateMessageSend,
    validateErrors,
    validateName2,
    work_with_us,
  },
}) => {
  const intl = useIntl()
  const lang = intl.locale
  const isBrowser = typeof window !== "undefined"
  const fileRef = useRef(null)
  const [file, setFile] = useState(null)
  const [isChecked, toggleChecked] = useState(false)
  const [formErrors, setFormErrors] = useState([])
  const [formSuccess, setFormSuccess] = useState(false)
  const scrollRef = useRef(null)
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    mail: "",
    message: "",
  })

  const updateField = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const displayRodo = rodo => {
    if (rodo) {
      // const rodoArray = rodo.split(" ")
      // const rodoLastWords = rodoArray.at(-2) + " " + rodoArray.at(-1)
      // rodoArray.pop()
      // rodoArray.pop()
      // const rodoFirstWords = rodoArray.join(" ") + " "

      return (
        <>
          <RodoLink
            to={lang === "pl" ? "/polityka_prywatnosci/" : "/privacy_policy/"}
          >
            {rodo}
          </RodoLink>
        </>
      )
    }
  }

  const handleFileInput = e => {
    setFile(e.target.files[0])
  }

  const resetForm = () => {
    setFormData({
      name: "",
      phone: "",
      mail: "",
      message: "",
    })
  }

  const sendForm = e => {
    e.preventDefault()

    const validation = validateForm()

    if (validation !== true) {
      setFormErrors(validation)

      return false
    } else {
      setFormErrors([])
    }

    var formdata = new FormData()
    formdata.append("firstAndLastName", formData.name)
    formdata.append("message", formData.message)
    formdata.append("phoneNumber", formData.phone)
    formdata.append("email", formData.mail)

    if (file) formdata.append("file", file)

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      formData: formdata,
    }

    fetch(process.env.GATSBY_CONTACT_URL_API, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .then(() => {
        setFormSuccess(true)
        resetForm()
      })
      .catch(error => console.log("error", error))

    return false
  }

  const validateForm = () => {
    const errors = []
    const isEmpty = v => v.trim() === ""
    const hasLengthBetween = (v, a, b) => v.length >= a && v.length <= b
    const isPhoneNumber = v => /[0-9\+]{9,13}/.test(v.replace(/[\s]/g, ""))
    // Regex below copied from https://emailregex.com/
    const isEmailAddress = v =>
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      )

    if (isEmpty(formData.name)) {
      errors.push(validateName2)
    } else if (hasLengthBetween(formData.name, 3, 50) === false) {
      errors.push(validateName)
    }

    if (isPhoneNumber(formData.phone) === false) {
      errors.push(validatePhone)
    }

    if (isEmailAddress(formData.mail) === false) {
      errors.push(validateEmail)
    }

    if (hasLengthBetween(formData.message, 10, 1000) === false) {
      errors.push(validateMessage)
    }

    if (enableAttachment) {
      const a =
        "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"

      if (file && !a.includes(file.type)) {
        errors.push(validateCv)
      }
    }

    if (errors.length) return errors

    return true
  }

  useEffect(() => {
    if (window.location.hash === "#form" && isBrowser) {
      setTimeout(() => {
        scrollRef.current.scrollIntoView(true)
      }, 0)
    }
  }, [])

  return (
    <Main>
      <FakeScrollBox ref={scrollRef} />
      <MainForm onSubmit={sendForm}>
        {message ? (
          <MainHeader>{work_with_us}</MainHeader>
        ) : (
          <MainHeader>{contact_form}</MainHeader>
        )}

        {(formSuccess || formErrors || message) && (
          <FormMessage>
            {message && <FormMessageSpecial>{formSubtitle}</FormMessageSpecial>}
            {formErrors.length > 0 && (
              <>
                <b>{validateErrors}</b>
                <ul>
                  {formErrors.map(e => (
                    <li key={e}>{e}</li>
                  ))}
                </ul>
              </>
            )}
            {formSuccess && <b>{validateMessageSend}</b>}
          </FormMessage>
        )}
        <Wrapper>
          <StyledInput
            id="name"
            type="text"
            placeholder={name}
            value={formData.name}
            onChange={e => updateField("name", e.target.value)}
          />
          <StyledInput
            id="phone"
            type="text"
            placeholder={phone}
            value={formData.phone}
            onChange={e => updateField("phone", e.target.value)}
          />
          <StyledInput
            id="mail"
            type="text"
            placeholder={mail}
            value={formData.mail}
            onChange={e => updateField("mail", e.target.value)}
          />
          <StyledTextArea
            id="message"
            placeholder={t_message}
            onChange={e => updateField("message", e.target.value)}
          >
            {formData.message}
          </StyledTextArea>
          <CheckBoxText id="rodotext">{displayRodo(rodo)}</CheckBoxText>
          <FormSubmit id="form-submit">
            {enableAttachment && !file && (
              <CVBox onClick={e => fileRef.current && fileRef.current.click()}>
                <input
                  type="file"
                  accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  ref={fileRef}
                  onChange={handleFileInput}
                  style={{ display: "none" }}
                />
                <img src={cvIcon} alt="ikonka cv" />
                <p>{sendCv}</p>
              </CVBox>
            )}
            {file && (
              <FileNameBox onClick={() => setFile(null)}>
                <img src={exitButton} alt="icon" />
                <p>{file.name}</p>
              </FileNameBox>
            )}

            <StyledGoldButton>{send}</StyledGoldButton>
          </FormSubmit>
        </Wrapper>
      </MainForm>
    </Main>
  )
}

export default FormComponent
